import "data-layer-helper/dist/data-layer-helper";

export default function registerDatalayerListener(datalayer, listener, listenToPast = false) {
    if (datalayer) {
        return new DataLayerHelper(datalayer, listener, listenToPast);
    }
    return null;
}
